import { isClubRotaract } from './isClubRotaract';

export const isRotaractLeadership = (isManager: boolean, clubType?: string) => {
  const isRotaractClub = clubType ? isClubRotaract(clubType) : false;

  return isRotaractClub && isManager;
};
